/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
// Composables
import { createVuetify } from 'vuetify'
import { VChip } from 'vuetify/components/VChip'
import { VTimePicker } from 'vuetify/labs/VTimePicker'
import vTextFieldSlow from '@/components/globals/vTextFieldSlow.vue'
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    lang: {
      current: 'pt',
    },
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#000000',
          secondary: '#ffffff',
          tertiary: '#262626',
          success: '#52a956',
          error: '#b72020',
          text: '#121212',
          background: '#fff',
          default: '#000000',
          inverted: '#000000',
          soft: '#e8e8e8',
          link: '#3378ff',
        },
      },
      dark: {
        colors: {
          primary: '#ffffff',
          secondary: '#000000',
          tertiary: '#262626',
          error: '#b72020',
          success: '#52a956',
          text: '#bfbfbf',
          background: '#000',
          default: '#000000',
          inverted: '#ffffff',
          soft: '#373737',
          link: '#3378ff',
        },
      },
    },
  },
  aliases: {
    VChipBlack: VChip,
  },
  defaults: {
    VChipBlack: {
      class: 'v-chip--black',
    },
  },
  components: {
    VTimePicker,
    vTextFieldSlow,
  },
})
